import { createActionBarEffect } from '@databases/action-bar/selections-effect';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import {
  type SelectionEffectFeature,
  type SelectionFeatureActivationContext,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface ActionBarEffectFeatureLifecycleDeps {
  contentId: string;
  databaseAdapter: DatabaseAdapter;
}

const isActionBarSupportedLayoutType = (
  layoutType: SelectionFeatureActivationContext['layoutType'],
): boolean =>
  layoutType === DatabaseLayoutType.TABLE || layoutType === DatabaseLayoutType.TIMELINE;

export function createActionBarEffectFeature(
  lifecycleDeps: ActionBarEffectFeatureLifecycleDeps,
): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.ACTION_BAR_EFFECT,
    type: 'effect',
    isEnabled: (ctx) => isActionBarSupportedLayoutType(ctx.layoutType),
    factory: () =>
      createActionBarEffect({
        selectionsApi: getService('SelectionsApi'),
        contentId: lifecycleDeps.contentId,
        databaseAdapter: lifecycleDeps.databaseAdapter,
        panelManager: getService('PanelManager'),
      }),
  };
}
